export const SET_SORT_BY = 'SET_SORT_BY/PROSPECT/@WISELY/WEB';
export const CLEAR_SORT_BY = 'CLEAR_SORT_BY/PROSPECT/@WISELY/WEB';

export const setSortBy = settings => ({
	type: SET_SORT_BY,
	payload: settings,
});

export const clearSortBy = () => ({
	type: CLEAR_SORT_BY,
});



// WEBPACK FOOTER //
// ./src/redux/prospects/prospect.action.js